import React from 'react';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';

import { Badge } from '@components';
import { QuestTopic } from '@models/Questionnaire/QuestTopicModel';
import { QuestTopicList } from '@models/Questionnaire/QuestTopicListModel';

const Container = styled(View)({
  mr: '$4',
  mb: '$5',
});

interface IQuestTopicItemProps {
  item: QuestTopic;
  list: QuestTopicList;
}

export const QuestTopicItem = observer(
  ({ item, list }: IQuestTopicItemProps) => {
    const disabled = !list.canSelectTopic && !item.isSelected;

    return (
      <Container>
        <Badge
          isActive={item.isSelected}
          onPress={item.toggleSelect}
          disabled={disabled}
        >
          {item.name}
        </Badge>
      </Container>
    );
  },
);
